// Produktly utility functions for user tracking and analytics

declare global {
  interface Window {
    Produktly?: {
      identifyUser: (userId: string, traits?: Record<string, unknown>) => void;
    };
  }
}

/**
 * Identify a user with Produktly
 * @param userId - The user's unique identifier
 * @param traits - User traits/properties to track
 */
export const identifyUser = (
  userId: string,
  traits?: Record<string, unknown>
) => {
  if (typeof window !== 'undefined' && window.Produktly) {
    try {
      window.Produktly.identifyUser(userId, traits);
      console.log('Produktly: User identified', { userId, traits });
    } catch (error) {
      console.error('Produktly: Error identifying user', error);
    }
  } else {
    console.warn('Produktly: Not available or not loaded yet');
  }
};

/**
 * Check if Produktly is available
 */
export const isProduktlyAvailable = (): boolean => {
  return typeof window !== 'undefined' && !!window.Produktly;
};

/**
 * Get Produktly configuration from environment variables
 */
export const getProduktlyConfig = () => {
  const config = {
    clientToken: import.meta.env.FE_PRODUKTLY_CLIENT_TOKEN,
    scriptUrl:
      import.meta.env.FE_PRODUKTLY_SCRIPT_URL ||
      'https://public.produktly.com/js/main.js',
  };

  if (!config.clientToken) {
    console.warn(
      'Produktly: Client token is missing. Please set FE_PRODUKTLY_CLIENT_TOKEN in your environment variables.'
    );
  }

  return config;
};
